export default __webpack_public_path__ + "static/media/36I-102724_-15726_0.38f61cd2.jpg";